import type { LibraryCardItem } from "~/features/library/types"

export type ContentSourceStatus = "unavailable" | "ready"

export interface ContentSourceResult {
  readonly status: ContentSourceStatus
  readonly items: readonly LibraryCardItem[]
}

/**
 * Downloads and Other Content are not served by the DCE graph. This port marks
 * the seam where the myLifeway licence/media REST services would attach. See
 * README.md — which source wins is DCD-6988, an open decision.
 */
export type ContentSource = () => ContentSourceResult

export const unavailableContentSource: ContentSource = () => ({
  status: "unavailable",
  items: [],
})
